import { render, staticRenderFns } from "./TitleAndDataLine.vue?vue&type=template&id=2c5acf72&"
import script from "./TitleAndDataLine.vue?vue&type=script&lang=js&"
export * from "./TitleAndDataLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports